import React from 'react';
import CompanyAdminLayout from '../../components/CompanyAdminLayout';

const PlaceholderPage = ({ title }) => {
  return (
    <CompanyAdminLayout>
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <div className="panel border border-border mt-6">
          <p className="text-sm text-muted-foreground">Coming soon.</p>
        </div>
      </div>
    </CompanyAdminLayout>
  );
};

export default PlaceholderPage;
